import PropTypes from "prop-types";
import CustomModal from "../CustomModal";

const MemberStatusModal = ({
  isOpen,
  onRequestClose,
  type = "success",
  title,
  description,
  buttonText = "Cancel",
  onButtonClick = null,
  reload = false,
}) => {
  const getImagePath = () => {
    switch (type) {
      case "success":
        return "/images/thumbs-up.png";
      case "warning":
        return "/images/delete-danger.png";
      case "info":
        return "/images/info-circle.png";
      default:
        return "/images/thumbs-up.png";
    }
  };

  const handleButtonClick = () => {
    if (onButtonClick) {
      onButtonClick();
    } else {
      onRequestClose();
      if (reload) window.location.reload();
    }
  };

  return (
    <CustomModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="edit-success-modal"
      contentLabel={`${title} Modal`}
    >
      <img
        src={`${process.env.PUBLIC_URL}${getImagePath()}`}
        alt={
          type === "success"
            ? "Success thumbs up icon"
            : type === "warning"
            ? "Warning icon"
            : type === "info"
            ? "Information icon"
            : "Status icon"
        }
      />
      <h2 style={{ fontWeight: "500" }}>{title}</h2>
      {description && <p>{description}</p>}
      <button type="button" onClick={handleButtonClick}>
        {buttonText}
      </button>
    </CustomModal>
  );
};

MemberStatusModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  type: PropTypes.oneOf(["success", "warning", "info"]),
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  buttonText: PropTypes.string,
  onButtonClick: PropTypes.func,
  reload: PropTypes.bool,
};

export default MemberStatusModal;
